// extracted by mini-css-extract-plugin
module.exports = {"storyboard":"StoryboardBlock_storyboard__Es81e","storyboard__links":"StoryboardBlock_storyboard__links__a_IpM"};